import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=8d594010&"
import script from "./mail.vue?vue&type=script&lang=ts&"
export * from "./mail.vue?vue&type=script&lang=ts&"
import style0 from "./mail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports